import { PaginatedTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { TimezoneCtxProvider } from '../../../../../../core/context/timezone.context';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { GlobalSchedulesNoMatchesReport } from '../types';

export function GlobalSchedulesNoMatchesReportResult({
  values,
  result,
}: ReportResultProps<GlobalSchedulesNoMatchesReport>) {
  const { formatMessage } = useIntl();

  return (
    <TimezoneCtxProvider
      value={{
        timezone: values.timezone,
      }}
    >
      <PaginatedTable
        data={result.items}
        columns={[
          {
            Header: formatMessage({
              id: 'audit.props.customId',
              defaultMessage: 'Custom ID',
            }),
            accessor: (item) => item.schedule.customId,
            w: 15,
          },
          {
            Header: formatMessage({
              id: 'common.station',
              defaultMessage: 'Emisora',
            }),
            accessor: (item) => item.schedule.station.name,
            w: 12,
          },
          {
            Header: formatMessage({
              id: 'common.datetime',
              defaultMessage: 'Fecha y hora',
            }),
            accessor: (item) => (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <LDate
                  value={item.schedule.datetime}
                  day="2-digit"
                  month="2-digit"
                  year="2-digit"
                />
                <LTime value={item.schedule.datetime} />
              </div>
            ),
          },
          {
            Header: formatMessage({
              id: 'audit.gipReport.result.campaign',
              defaultMessage: 'Campaña',
            }),
            accessor: (item) => item.schedule.campaign,
          },
          {
            Header: formatMessage({
              id: 'audit.gipReport.result.advertiser',
              defaultMessage: 'Anunciante',
            }),
            accessor: (item) => item.schedule.advertiser,
          },
          {
            Header: formatMessage({
              id: 'audit.gipReport.result.version',
              defaultMessage: 'Versión',
            }),
            accessor: (item) => item.schedule.version,
          },
          {
            Header: formatMessage({
              id: 'audit.gipReport.result.order',
              defaultMessage: 'Orden',
            }),
            accessor: (item) => item.schedule.order,
          },
          {
            Header: formatMessage({
              id: 'audit.gipReport.result.type',
              defaultMessage: 'Tipo',
            }),
            accessor: (item) => item.schedule.type,
            w: 10,
          },
        ]}
      />
    </TimezoneCtxProvider>
  );
}
